import React from 'react';
import { NextPage } from 'next';

import calculate from '@r1-frontend/api-domru/api-tariffs/v1/tariff/calculate';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import Layout from '~/src/features/_layout';
import Constructor from '~/src/features/tariffBuilder';
import { isConstructorAuthEnabled } from '~/src/features/tariffBuilder/constants/abnVariants';
import { initialProps } from '~/src/helpers/basePageFunc';
import getRequester from '~/src/helpers/getRequester';
import { nonPermanentRedirect } from '~/src/helpers/url';

type TConstructorPageProps = {
    cityIn: string,
    companyName: string,
}

const ConstructorPage: NextPage<TConstructorPageProps> = ({ cityIn, companyName }): JSX.Element => {
    return (
        <Layout
            title={`Тариф Конструктор от ${companyName} в ${cityIn} | Настроить тариф под себя`}
            description={`Соберите свой оптимальный тариф в конструкторе от ${companyName}. 
            Выбирайте и платите только за те услуги, которые вам действительно нужны: комфортная скорость интернета, 
            цифровое ТВ, подписки на онлайн-кинотеатры, оборудование и полезные сервисы.`}
            withMenu={true}
            withFooter={true}
            withChat={false}
            bgColor={COLORS.BgMain}
        >
            <Constructor/>
        </Layout>
    );
};

ConstructorPage.getInitialProps = async(ctx): Promise<TConstructorPageProps> => {
    const { req, res, store, query } = ctx;

    const { validatedAccessToken } = await initialProps(ctx, { isNeedAuthData: true });

    const { city: { currentCity }, auth: { clientProducts } } = store.getState();
    const doRequest = getRequester(req);

    const constructorResponse = await doRequest.apiTariffs(calculate({}));

    if (validatedAccessToken && !isConstructorAuthEnabled()) {
        nonPermanentRedirect({ res, location: '/' });
    }

    if (validatedAccessToken && !clientProducts?.isConstructor && !query.bannerId) {
        nonPermanentRedirect({ res, location: '/lk/change-tariff' });
    }

    /**
     * If the calculate method of the api-tariff answers with a 404 status code, we should redirect to the root of the
     * site. The 404 status code from the method means that the billing service does not correctly process a request by
     * a providerId
     */
    if (!constructorResponse.isSuccess && constructorResponse.error.status === 404) {
        nonPermanentRedirect({ res, location: '/' });
    }

    return {
        cityIn: currentCity.cityIn,
        companyName: currentCity.companyName,
    };
};

export default ConstructorPage;
